export default __webpack_public_path__ + "static/modal01_02-sp-b0cda3a333a4fb89cf33f983bfe3cf83.svg";